import { userToken, userCookieId } from "../utils/helper";

/**
 * Base URL for the main backend API.
 * Defaults to "http://localhost:8000/api" if not provided via environment variables.
 * 
 * @constant {string}
 */
export const BASE_URL: string =
  process.env.REACT_APP_BASE_BACKEND_URL ?? "http://localhost:8000/api";

/**
* Base URL for the chat service API.
* Defaults to "http://localhost:8001" if not provided via environment variables.
* 
* @constant {string}
*/
export const BASE_CHAT_URL: string =
  process.env.REACT_APP_BASE_CHAT_URL ?? "http://localhost:8001";

/**
* Base WebSocket URL for the chat service.
* Defaults to "ws://localhost:8001" if not provided via environment variables.
* 
* @constant {string}
*/
export const BASE_CHAT_SOCKET: string =
  process.env.REACT_APP_BASE_CHAT_SOCKET ?? "ws://localhost:8001";

  /**
 * Authentication token for the current user.
 * Retrieved from a helper function. Can be null if not available.
 * 
 * @constant {string|null}
 */
export const token: string | null = userToken;

/**
 * Current logged-in user's ID.
 * Retrieved from a helper function. Defaults to "0" if not available.
 * 
 * @constant {string}
 */
export const userId: string = userCookieId ?? "0";
// export const roleName: string | null = getRole("_auth_state");
